// extracted by mini-css-extract-plugin
module.exports = {"link":"NOHEfficiencyTile_link__2I1ii","arrow":"NOHEfficiencyTile_arrow__1Ad-X","tileTitle":"NOHEfficiencyTile_tileTitle__2sHns"};